module.exports = __webpack_public_path__ + "static/1-ad26c974d03b14d98ec53202c660790c.png";